import { createFileRoute } from '@tanstack/react-router';
import { CalculatorPage } from '@/features/desmos/CalculatorPage';
import { requireCalculatorAccess } from '@/lib/routeGuards';

export const Route = createFileRoute('/_authed/calculator')({
  beforeLoad: requireCalculatorAccess,
  component: CalculatorPage,
});
